import React from 'react';
export var BrowserFeatureContext = React.createContext({
    supportsWebp: false,
    supportsLazy: false,
});
BrowserFeatureContext.displayName = 'BrowserFeatureContext';
//# sourceMappingURL=BrowserFeatureContext.js.map